import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Script from 'next/script';
import { observer } from 'mobx-react';
import Head from 'next/head';
import React from 'react';
import Header from './Header';
import Nav from './Nav';
import Footer from './Footer';
import GlobalRefresh from './GlobalRefresh';
import { sitemap } from '@/utils';
import { DEFAULT } from '@/constants';
var Layout = observer(function(param) {
    var children = param.children;
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("link", {
                        rel: "dns-prefetch",
                        href: "//kaas.moqun.cn"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "shortcut icon",
                        href: "/img/favicon.ico"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=false"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "Description",
                        content: "".concat(DEFAULT.NET, " allows you to explore and search the ").concat(DEFAULT.NET, " blockchain for transactions, addresses, tokens, prices and other activities taking place on ").concat(DEFAULT.NET, " (").concat(DEFAULT.TOKEN, ")")
                    }),
                    /*#__PURE__*/ _jsx("title", {
                        children: DEFAULT.NET
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "canonical",
                        href: sitemap
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx(Nav, {}),
            /*#__PURE__*/ _jsx(Script, {
                src: "/js/icon.min.js",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ _jsx(GlobalRefresh, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "mx-auto min-h-[calc(100vh-229px)] container-w",
                children: [
                    " ",
                    children,
                    " "
                ]
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    }));
});
export default Layout;
